/**
 * For use to display cert on CM Conclusion page
 */

import React from 'react';
import PropTypes from 'prop-types';

import { DateTime } from 'luxon';

import certUtils from '../../../global/utils/certUtils';

const AchievedModuleCertificate = ({
  certificateTemplate
  , moduleCertificate
  , sponsor
  , contentModule
  , user
}) => {
  let completed = DateTime.fromISO(moduleCertificate.issuedDate);
  // let expires = DateTime.fromISO(moduleCertificate.expires);

  /**
   * CURRENT 1.6.2:
   * cert.expires is the only thing that matters when determining expiration. 
   * contentModule.certificateDuration matters, but only applies when the cert
   * is first created. if they want to go in and change it on the module level
   * they can, but it will NOT affect any existing moduleCertificates
   * 
   * DEPRECIATED:
   * NOTE: we need to make expiration date determined directly from the
   * contentModule.certificateDuration in the event the module is edited after
   * the fact to either adjust the duration period, or eliminate it altogether.
   * However, we need to KEEP moduleCertificate.expires for some legacy manually
   * added certs.
   */

  
   // const expires = contentModule.certificateDuration ? completed.plus(contentModule.certificateDuration,'years') : DateTime.fromISO(moduleCertificate.expires);

   const certIsValid = certUtils.checkIfValid(moduleCertificate, contentModule);
  /**
   * Luxon diff returns a Duration object that itself has a values object
   * with keys defined in the above array argument, but ONLY if they exist.
   * i.e. if the diff is exactly two years, then the object will be {years: 2};
   * if it's 2 years and 8 months and 23 days, the object will be
   * {years: 2, months: 8, days: 23};
   * BUT if it's 2 years 8 months and ZERO days, the object will just be
   * {years: 2, months 8}
   * see https://moment.github.io/luxon/docs/manual/math.html#diffs for reference
   */
  return (
    <div className="certificate -achieved">
      <div className="-cert-content">
        <div className="-cert-header">
          { certificateTemplate && certificateTemplate.partnerLogoUrl ? 
            <div className="-sponsor-info">
              <div className="-sponsor-logo">
                <img src={certificateTemplate.partnerLogoUrl}/>
              </div>
            </div>
            :
            null 
          }
          {/* { sponsor ?
            <div className="-sponsor-info">
              <div className="-sponsor-logo">
                { sponsor.logo ?
                  <img alt="Sponsor logo" src={sponsor.logo}/>
                  :
                  null
                }
              </div>
              { sponsor.name ? 
                <div className="-sponsor-name">{sponsor.name}</div>
                :
                null 
              }
              <hr/>
            </div>
            :
            null 
          } */}
        </div>
        <div className="-cert-body">
          { moduleCertificate.status !== 'completed' ?
            <div className="alert-message danger banner u-centerText"><strong>NOTE: </strong> This certificate is {moduleCertificate.status.toUpperCase()}</div>
            :
            null
          }
          <h1 className="u-centerText">Certificate of Completion</h1>
          <div className="-certifies-that">{certificateTemplate && certificateTemplate.certifiesText ? certificateTemplate.certifiesText : 'This certifies that'}</div>
          <div className="-completor">{user.firstName} {user.lastName}</div>
          <div className="-has-successfully">{certificateTemplate && certificateTemplate.hasCompletedText ? certificateTemplate.hasCompletedText : 'has successfully completed'}</div>
          <div className="-tm-title">{contentModule.title}</div>
          <div className="-dates">

            { contentModule.version ? 
              <div>
                <strong>Version:</strong> {contentModule.version} 
              </div>
              :
              null 
            }
            
            {/* Show the attestation date instead of issued date if cert requires attestation */}
            { contentModule.requiresAttestation ? 
              <div className="-completion">
                <strong>Date of completion:</strong> { !moduleCertificate.attestationDate ? <em>Requires attestation</em> : DateTime.fromISO(moduleCertificate.attestationDate).toLocaleString(DateTime.DATETIME_FULL)}
              </div>
              :
              <div className="-completion">
                <strong>Date of completion:</strong> {DateTime.fromISO(moduleCertificate.issuedDate).toLocaleString(DateTime.DATETIME_FULL)}
              </div>
            }
            
            {/* TODO: these two will always both show, so which one takes precedence? */}
            { moduleCertificate.expires ?
              <div className="-expiration">
                <strong>Certificate expiration:</strong> {DateTime.fromISO(moduleCertificate.expires).toLocaleString(DateTime.DATETIME_FULL)}
              </div>
              :
              null
            }
          </div>

          { contentModule.certificateUnits ? 
            <div>
              <strong>Credits Earned:</strong> {contentModule.certificateUnits} {certificateTemplate && certificateTemplate.creditsEarnedSuffix ? certificateTemplate.creditsEarnedSuffix :  _.upperCase(contentModule.certificateType)}
            </div>
            :
            null 
          }
        </div>
        <div className="-cert-sig">
          { certificateTemplate ? 
            <div className="-signer-info">
              <div className="-signature">
                <img src={certificateTemplate.signerImageUrl}/>
              </div>
              <div className="-signer-name-position">
                {certificateTemplate.signerName} &mdash; {certificateTemplate.signerPosition}
              </div>
            </div>
            :
            <div className="-signer-info">
              <div className="-signature">
                <img src="https://pro-ficiency-static.s3.us-east-2.amazonaws.com/images/margarets-signature-v4.png"/>
              </div>
              <div className="-signer-name-position">
                Margaret Richardson &mdash; Executive Director, Quality and Compliance
              </div>
            </div>
          }
        </div>
        <div className="-cert-footer">
          <div className="yt-row with-gutters space-between">
            <div className="yt-col _60">
              { certificateTemplate && certificateTemplate.accreditationLogoUrl ? 
                <div className="-accreditor-info">
                  <div className="-accreditor-logo">
                    <img alt="Accreditation body" src={certificateTemplate.accreditationLogoUrl}/>
                  </div>
                  <div className="-accreditor-description">
                    {certificateTemplate.accreditationDescription}
                  </div>
                </div>
                :
                <div className="-accreditor-info">
                  <div className="-accreditor-logo">
                    <img alt="Accreditation body" src="/img/cert-icons/cert-icon-dark@4x.png"/>
                  </div>
                  <div className="-accreditor-description">
                    Simulations Plus achieves learner engagement, competency and compliance using our Pro-ficiency adaptive learning platform. By leveraging our simulation-based approach, Sponsors, sites and individual learners experience real-world training that allows for practice and application of concepts in a risk-free environment, decreasing errors and improving comprehension, retention, and overall performance. 
                  </div>
                </div>
              }
            </div>
            <div className="yt-col _25">
              { (!certificateTemplate || (certificateTemplate && certificateTemplate.bottomRightStatus === 'useSponsorLogo')) && sponsor ?
                <div className="-sponsor-info">
                  <div className="-sponsor-logo">
                    { sponsor.logo ?
                      <img alt="sponsor-logo" src={sponsor.logo}/>
                      :
                      null
                    }
                  </div>
                </div>
                : certificateTemplate && certificateTemplate.bottomRightStatus === 'overrideSponsorLogo' ? 
                  <div className="-sponsor-info">
                    <div className="-sponsor-logo">
                      { certificateTemplate.bottomRightLogoUrl ?
                        <img alt="sponsor-logo" src={certificateTemplate.bottomRightLogoUrl}/>
                        :
                        null
                      }
                    </div>
                  </div>
                :
                null 
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

AchievedModuleCertificate.propTypes = {
  certificateTemplate: PropTypes.object 
  , moduleCertificate: PropTypes.object.isRequired
  , sponsor: PropTypes.object
  , contentModule: PropTypes.object.isRequired
  , user: PropTypes.object.isRequired
}

AchievedModuleCertificate.defaultProps = {
  certificateTemplate: null 
  , sponsor: null
}

export default AchievedModuleCertificate;



// WEBPACK FOOTER //
// modules/moduleCertificate/components/AchievedModuleCertificate.js.jsx